"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExitButton = exports.AsOfWrap = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const wl_ui_kit_1 = require("@invent/wl-ui-kit");
exports.AsOfWrap = (0, styled_components_1.default)(wl_ui_kit_1.Overline) `
  align-self: end;
  color: ${(0, wl_ui_kit_1.getColorShade)('onSurface', 'lowEmphasis')};
  font-weight: 700;
`;
exports.ExitButton = (0, styled_components_1.default)(wl_ui_kit_1.Button) `
  padding: 0;
`;
exports.default = styled_components_1.default.footer `
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: ${(props) => props.$withExit ? '1fr min-content min-content' : '1fr min-content'};
  gap: ${(0, wl_ui_kit_1.getSizeBy)(3)};
  align-items: center;
  padding: 0;
`;
